import { useState, useLayoutEffect, useCallback } from "react"

export default key => {
  const [storedValue, setStoredValue] = useState(false)
  const [componentMounted, setComponentMounted] = useState(false)

  const setMode = useCallback(
    mode => {
      typeof window !== "undefined" &&
        window.localStorage.setItem(key, JSON.stringify(mode))
      setStoredValue(mode)
    },
    [key]
  )

  const toggleTheme = () => {
    setMode(!storedValue)
  }

  useLayoutEffect(() => {
    const localTheme =
      typeof window !== "undefined" && window.localStorage.getItem("Theme")

    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches &&
    !localTheme
      ? setMode(true)
      : localTheme
      ? setStoredValue(JSON.parse(localTheme))
      : setMode(false)

    setComponentMounted(true)
  }, [key, setMode])

  return [storedValue, toggleTheme, componentMounted]
}
